import Vue from 'vue';
import VueFilter from 'vue-filter';

// Init Vue plugins.
Vue.use(VueFilter);

// Register editor component of the admin side.
Vue.component('canvas--editor-admin', require('./editor/Admin').default);
